import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Polyline, { points: "6 9 12 15 18 9", stroke: `${color}` })
    }
  );
};
Icon.displayName = "ChevronDown";
const ChevronDown = memo(themed(Icon));
export {
  ChevronDown
};
//# sourceMappingURL=chevron-down.js.map
